import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import useStores from '$src/hooks/useStores';
import useLocationContext from '$src/hooks/useLocationContext';
import {
  redirectToOnboardingDeviceAuthorization,
  redirectToOnboardingEmergencyContacts,
  redirectToOnboardingAlertPreferences,
} from '$src/utils/redirect';
import { Ingress } from '@amzn/ring-react-components/csr/components/Ingress';
import { DevicesIcon, SharedUsersIcon } from '@ring-icons';

import './index.less';

function Settings({ settingText }) {
  const locationId = useLocationContext();
  const {
    locationContextStore: { hasCustomSettings },
  } = useStores();

  return (
    <>
      <div className="settings__title">{settingText}</div>
      <div data-testid="onboarding-settings" className="settings__container">
        <Ingress
          data-testid="onboarding-devices"
          image={<DevicesIcon />}
          onClick={() => redirectToOnboardingDeviceAuthorization(locationId)}
          title={<b>Enrolled Devices</b>}
        >
          {hasCustomSettings.devices
            ? 'We will use the Enrolled Devices that you selected.'
            : 'All compatible outdoor devices will be enrolled. Devices can be enrolled or unenrolled anytime in the Ring app.'}
        </Ingress>

        <Ingress
          image={<SharedUsersIcon />}
          data-testid="onboarding-emergency-contacts"
          onClick={() => redirectToOnboardingEmergencyContacts(locationId)}
          title={<b> Emergency Contacts </b>}
        >
          We will use the Emergency Contacts that you selected in alarm settings.
        </Ingress>

        <Ingress
          image={<SharedUsersIcon />}
          data-testid="onboarding-alert-preferences"
          onClick={() => redirectToOnboardingAlertPreferences(locationId)}
          title={<b> Alert Preferences </b>}
        >
          {hasCustomSettings.preferences
            ? 'We will use the Alert Preferences that you selected.'
            : 'We will alert all Emergency Contacts during emergencies and the first Emergency Contact for all other notifications.'}
        </Ingress>
      </div>
    </>
  );
}

Settings.propTypes = {
  settingText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

Settings.defaultProps = {
  settingText: 'Settings',
};

export default observer(Settings);
